import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const tabs = style(
  {
    display: "none"
  },
  media(queries.medium, {
    display: "flex",
    paddingBottom: "0.85rem"
  })
);

export const tabGroup = style({
  flex: 1
});

export const link = style({
  color: colors.hooplaTextColor,
  fontSize: "1.2rem",
  textDecoration: "none",
  paddingBottom: "0.85rem",
  borderBottom: "2px solid transparent",
  $nest: {
    "&:not(:last-child)": {
      marginRight: "2rem"
    }
  }
});

export const active = style({
  color: colors.hooplaBlue,
  borderBottomColor: colors.hooplaBlue
});
